export const APIKey = 'Kneedler'

export const BASE_URL = `https://api.github.com/users/${APIKey}/repos`